// extracted by mini-css-extract-plugin
module.exports = {"cnt":"CopyWithMessage_cnt__1QYyI","children":"CopyWithMessage_children__1jopf","message":"CopyWithMessage_message__1mI-R"};